/* ArtsBouquet home – interactions (safe to load once per page) */
(function () {
  if (window.__abHomeInit) return;
  window.__abHomeInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    root = root || document;

    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 }) : null;
    root.querySelectorAll('.abh-rise, .abh-hero-box').forEach(function (el) {
      if (io && !reduce) io.observe(el); else el.classList.add('is-in');
    });

    root.querySelectorAll('.abh-flip').forEach(function (f) {
      if (f.dataset.abInit) return; f.dataset.abInit = 1;
      f.addEventListener('click', function (ev) {
        if (window.matchMedia('(hover: none)').matches && !f.classList.contains('is-flipped')) {
          ev.preventDefault(); f.classList.add('is-flipped');
        }
      });
    });

    root.querySelectorAll('.abh-reveal').forEach(function (h) {
      if (h.dataset.abInit) return; h.dataset.abInit = 1;
      if (reduce) return;
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (t) {
        var frag = document.createDocumentFragment();
        t.textContent.split(/(\s+)/).forEach(function (w) {
          if (!w) return;
          if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
          var word = document.createElement('span'); word.style.whiteSpace = 'nowrap';
          for (var i = 0; i < w.length; i++) { var c = document.createElement('span'); c.className = 'ch'; c.textContent = w[i]; word.appendChild(c); }
          frag.appendChild(word);
        });
        t.parentNode.replaceChild(frag, t);
      });
      h._chars = h.querySelectorAll('.ch');
    });

    root.querySelectorAll('.abh-feat').forEach(function (s) {
      if (s.dataset.abInit) return; s.dataset.abInit = 1;
      var f = s.querySelector('.abh-follow'); if (!f) return;
      var x = 0, y = 0, tx = 0, ty = 0, raf;
      function loop() { x += (tx - x) * .12; y += (ty - y) * .12; f.style.transform = 'translate(' + x + 'px,' + y + 'px)'; raf = requestAnimationFrame(loop); }
      s.addEventListener('mouseenter', function () { s.classList.add('is-hover'); if (!raf) loop(); });
      s.addEventListener('mouseleave', function () { s.classList.remove('is-hover'); cancelAnimationFrame(raf); raf = null; });
      s.addEventListener('mousemove', function (e) {
        var r = s.getBoundingClientRect();
        tx = e.clientX - r.left - f.offsetWidth / 2; ty = e.clientY - r.top - f.offsetHeight / 2;
        s.classList.toggle('is-right', e.clientX - r.left > r.width / 2);
      });
    });

    root.querySelectorAll('.abh-quotes').forEach(function (q) {
      if (q.dataset.abInit) return; q.dataset.abInit = 1;
      var tr = q.querySelector('.abh-q-track');
      q.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var w = tr.clientWidth, d = +b.dataset.dir, max = tr.scrollWidth - w;
          var next = tr.scrollLeft + d * w;
          if (next > max + 5) next = 0; if (next < -5) next = max;
          tr.scrollTo({ left: next, behavior: 'smooth' });
        });
      });
    });
  }

  function onScroll() {
    var vh = window.innerHeight;
    document.querySelectorAll('.abh-reveal').forEach(function (h) {
      if (!h._chars) return;
      var r = h.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (vh * 0.9 - r.top) / (vh * 0.55)));
      var on = Math.round(p * h._chars.length);
      for (var i = 0; i < h._chars.length; i++) h._chars[i].classList.toggle('on', i < on);
    });
    document.querySelectorAll('.abh-band').forEach(function (b) {
      var r = b.getBoundingClientRect(), p = (vh - r.top) / (vh + r.height);
      var l = b.querySelectorAll('.abh-band-line');
      if (l[0]) l[0].style.transform = 'translateX(' + (-p * 30 + 5) + '%)';
      if (l[1]) l[1].style.transform = 'translateX(' + (p * 30 - 25) + '%)';
    });
  }

  function boot() { init(document); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); onScroll(); });
})();
